import { render, staticRenderFns } from "./GastosAdmon.vue?vue&type=template&id=8b808260"
import script from "./GastosAdmon.vue?vue&type=script&lang=js"
export * from "./GastosAdmon.vue?vue&type=script&lang=js"
import style0 from "./GastosAdmon.vue?vue&type=style&index=0&id=8b808260&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports